"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/TrafficLights.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TrafficLights = function TrafficLights(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 66.15 144.96"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Traffic Lights icon"), _react2.default.createElement("path", {
    d: "M59 0H7.19A7.22 7.22 0 0 0 0 7.19V124a7.22 7.22 0 0 0 7.19 7.19h17.63V145h16.46v-13.78H59a7.22 7.22 0 0 0 7.15-7.22V7.19A7.22 7.22 0 0 0 59 0zM33.08 120.42A15.61 15.61 0 1 1 48.7 104.8a15.61 15.61 0 0 1-15.62 15.62zm0-41.11a15.61 15.61 0 1 1 15.6-15.6 15.61 15.61 0 0 1-15.6 15.6zm0-40.09a15.61 15.61 0 1 1 15.6-15.61 15.61 15.61 0 0 1-15.6 15.61z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = TrafficLights;